import './metrics_view.js.coffee'
Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.TwitterMetricsView extends Monitoring.Reports.DailyInsights.MetricsView
  template: JST['backbone/templates/monitoring/reports/daily_insights/twitter_metrics']

  initialize: (@options = {}) =>
  	@$el.addClass('tw-metrics')
  	super(@options)
